import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
// import Home from '../views/Home.vue'
import Dashboard from "../views/Dashboard.vue";
import Browse from "../views/Browse.vue";
import Hire from "../views/Hire.vue";
import DevProfile from "../views/DevProfile.vue";
import SkillScore from "../views/SkillScore.vue";
import NoHireYet from "../views/NoHireYet.vue";
import Bidding from "../views/Bidding.vue";
import ProjectDetails from "../views/ProjectDetails.vue";
import ProjectBiddingClosed from "../views/ProjectBiddingClosed.vue";
import Hired from "../views/Hired.vue";
import Onboarding from "../views/Onboarding.vue";
import Saved from "../views/Saved.vue";
import PaymentBudget from "../views/PaymentBudget.vue";
import PaymentSummary from "../views/PaymentSummary.vue";
import Settings from "../views/Settings.vue";
import MyProject from "../views/MyProject.vue";
import DevDetails from "../views/DevDetails.vue";
import OnboardingReview from "../views/OnboardingReview.vue";
import JobReview from "../views/JobReview.vue";
import HireForJob from "../views/HireForJob.vue";
import Chat from "../views/Chat.vue";
import Login from "../views/Login.vue";
import Forgotpassword from "../views/Forgotpassword.vue";
import FindTalent from "../views/FindTalent.vue";

import DevNo from "../components/Hire/DevNo.vue";
import Stack from "../components/Hire/Stack.vue";
import Stage from "../components/Hire/Stage.vue";
import Specifications from "../components/Hire/Specifications.vue";
import JobPost from "../components/Hire/JobPost.vue";
import JobType from "../components/Hire/JobType.vue";
import Duration from "../components/Hire/Duration.vue";
import Location from "../components/Hire/Location.vue";
import PaymentPerHour from "../components/Hire/PaymentPerHour.vue";
import WorkHours from "../components/Hire/WorkHours.vue";
import Description from "../components/Hire/Description.vue";
import Fc from "../components/Hire/Fc.vue";
import Budget from "../components/Hire/Budget.vue";
import Bio from "../components/Hire/Bio.vue";
import FcJobPost from "../components/Hire/FcJobPost";
import FcBio from "../components/Hire/FcBio";
import FcCompanyBio from "../components/Hire/FcCompanyBio";
import FcDuration from "../components/Hire/FcDuration";
import FcExpertLevel from "../components/Hire/FcExpertLevel";
import FcSalary from "../components/Hire/FcSalary";
import FcStack from "../components/Hire/FcStack";
import FcWorkHours from "../components/Hire/FcWorkHours";

/* import Stage from "@/components/PostProject/Stage.vue";
import Description from "@/components/PostProject/Description.vue";
import Stack from "@/components/PostProject/Stack.vue";
import Specifications from "@/components/PostProject/Specifications.vue";
import WorkHours from "@/components/PostProject/WorkHours.vue";
import JobType from "@/components/PostProject/JobType.vue";
import Location from "@/components/PostProject/Location.vue";
import Duration from "@/components/PostProject/Duration.vue";
import DevNo from "@/components/PostProject/DevNo.vue"; */
import Payment from "@/components/PostProject/Payment.vue";
import MakeJobPost from "@/components/PostProject/MakeJobPost.vue";
/* import HireTalent from "../views/HireTalent.vue"; */
import JobRole from "../components/HireTalent/JobRole.vue";
import TechStack from "../components/HireTalent/TechStack.vue";
import TalentExperience from "../components/HireTalent/Experience.vue";
import SignUp from "../components/HireTalent/SignUp.vue";
import Register from "../views/Register.vue";

Vue.use(VueRouter);

const pageProgress = {
  func: [
    { call: "color", modifier: "temp", argument: "#ffb000" },
    { call: "fail", modifier: "temp", argument: "#6e0000" },
    { call: "location", modifier: "temp", argument: "top" },
    {
      call: "transition",
      modifier: "temp",
      argument: { speed: "1.5s", opacity: "0.6s", termination: 400 }
    }
  ]
};

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/home",
    name: "Home",
    component: MyProject,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/hire",
    name: "Hire",
    component: Hire,
    meta: {
      requiresAuth: true
    },
    children: [
      { path: "", component: Stage },
      { path: "stack", component: Stack },
      { path: "fc", component: Fc },
      { path: "budget", component: Budget },
      { path: "description", component: Description },
      { path: "specifications", component: Specifications },
      { path: "work-hours", component: WorkHours },
      { path: "job-type", component: JobType },
      { path: "location", component: Location },
      { path: "duration", component: Duration },
      { path: "dev-no", component: DevNo },
      { path: "payment", component: PaymentPerHour },
      { path: "make-job-post", component: JobPost },
      { path: "bio", component: Bio },
      { path: "job-post", component: FcJobPost },
      { path: "job-stack", component: FcStack },
      { path: "job-duration", component: FcDuration },
      { path: "job-work-hour", component: FcWorkHours },
      { path: "job-expert-level", component: FcExpertLevel },
      { path: "job-salary", component: FcSalary },
      { path: "company-bio", component: FcCompanyBio },
      { path: "job-bio", component: FcBio }
    ]
  },
  {
    path: "/hire-talent",
    name: "Hire",
    component: Hire,
    children: [
      { path: "", component: JobRole },
      { path: "tech-stack", component: TechStack },
      { path: "experience", component: TalentExperience },
      { path: "signup", component: SignUp }
    ]
  },
  {
    path: "/browse",
    name: "Browse",
    component: Browse,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/find-talent",
    name: "findtalent",
    component: FindTalent
  },
  {
    path: "/dev-profile",
    name: "profile",
    component: DevProfile,
    meta: {
      requiresAuth: false,
      progress: pageProgress
    }
  },
  {
    path: "/skill-score",
    name: "skill-score",
    component: SkillScore,
    meta: {
      requiresAuth: false,
      progress: pageProgress
    }
  },
  {
    path: "/not-hired",
    name: "not-hired",
    component: NoHireYet,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/bidding",
    name: "bidding",
    component: Bidding,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/project-details",
    name: "project-details",
    component: ProjectDetails,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/bidding-closed",
    name: "project-bidding-closed",
    component: ProjectBiddingClosed,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/hiring",
    name: "hired",
    component: Hired,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/onboarding",
    name: "onboarding",
    component: Onboarding,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    },
    children: [
      { path: "", component: Stage },
      { path: "description", component: Description },
      { path: "stack", component: Stack },
      { path: "specification", component: Specifications },
      { path: "work-hours", component: WorkHours },
      { path: "job-type", component: JobType },
      { path: "location", component: Location },
      { path: "duration", component: Duration },
      { path: "dev-num", component: DevNo },
      { path: "payment", component: Payment },
      { path: "make-job-post", component: MakeJobPost }
    ]
  },
  {
    path: "/saved",
    name: "saved",
    component: Saved,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/payment-budget",
    name: "payment-budget",
    component: PaymentBudget,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/payment-summary",
    name: "payment-summary",
    component: PaymentSummary,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/settings",
    name: "settings",
    component: Settings,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/my-projects",
    name: "my-projects",
    component: MyProject,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/dev-details",
    name: "dev-details",
    component: DevDetails,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/onboarding-review",
    name: "onboarding-review",
    component: OnboardingReview,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/job-review",
    name: "job-review",
    component: JobReview,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/hire-for-job",
    name: "hire-for-job",
    component: HireForJob,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/chat",
    name: "chat",
    component: Chat,
    meta: {
      requiresAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      hideForAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/forgot_password",
    name: "Forgotpassword",
    component: Forgotpassword,
    meta: {
      hideForAuth: true,
      progress: pageProgress
    }
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    window.scrollTo(0, 0);
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // console.log(store.getters.isLoggedIn);
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/login");
    // next()
  } else {
    next();
  }

  if (to.matched.some(record => record.meta.hideForAuth)) {
    if (store.getters.isLoggedIn) {
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
